import { render, staticRenderFns } from "./AspirantesConvertidosPoliciaTabContent.vue?vue&type=template&id=22ff5a24&scoped=true"
import script from "./AspirantesConvertidosPoliciaTabContent.vue?vue&type=script&lang=js"
export * from "./AspirantesConvertidosPoliciaTabContent.vue?vue&type=script&lang=js"
import style0 from "./AspirantesConvertidosPoliciaTabContent.vue?vue&type=style&index=0&id=22ff5a24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ff5a24",
  null
  
)

export default component.exports